import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { Help } from './KlaviyoHelpLink';
import { KlaviyoSetupMode } from './KlaviyoIntegrations';
import styles from './KlaviyoIntegrations.module.css';

export const KlaviyoConnectionModeSelector = ({
  onSelectMode,
  helpLink,
  isKlaviyoApp,
}: {
  onSelectMode: (mode: KlaviyoSetupMode) => void;
  helpLink: string;
  isKlaviyoApp?: boolean;
}) => {
  const featureFlags = useSelector(combinedFeatureFlagsSelector);
  return (
    <div
      className={classNames(styles.box, styles.boxWithHelp, {
        [styles.whiteBox]: featureFlags.compliant_klaviyo_app,
      })}
    >
      <div className={styles.boxContent}>
        <div className={styles.heading}>
          Sign in Directly with Klaviyo
          <Help link={helpLink} text="Read Tutorial" />
        </div>
        <div className={styles.connectionButtonsWrapper}>
          <PrimaryButton
            css={{ container: 'integrations__header-add-button-secondary' }}
            color={ButtonColor.secondaryBlue}
            onClick={() => onSelectMode('oauth')}
          >
            Sign in Directly
          </PrimaryButton>
        </div>
        {!isKlaviyoApp && (
          <div>
            <div className={styles.heading}>Connect with API Key</div>
            <div className={styles.connectionButtonsWrapper}>
              <PrimaryButton
                css={{ container: 'integrations__header-add-button-secondary' }}
                color={ButtonColor.secondaryBlue}
                onClick={() => onSelectMode('api_key')}
              >
                Connect with API Key
              </PrimaryButton>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
